import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { useNavigate, Link } from 'react-router-dom';
import { useContext } from 'react';
import SocialContext from '../../context/SocialContext';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import FeedbackIcon from '@mui/icons-material/Feedback';
import Conform from '../conform/Conform';

export default function Dropdown() {
    const { logoutfun, user, setOpen,setconformMessage,setconformAction } = useContext(SocialContext);

    const navigate = useNavigate();
    const PF = "https://socialshub.netlify.app/images/";

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <Conform call={"forlogout"}/>
            <React.Fragment>
                <Box sx={{ display: 'flex', alignItems: 'right', textAlign: 'center' }}>
                    <Tooltip title="Account settings">
                        <IconButton
                            onClick={handleClick}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <img src={user.profilePic ? user.profilePic : PF + "/person/noprofile.jpeg"} className="topbarImg" />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&:before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem onClick={() => { navigate(`/profile/${user._id}`) }}>
                        <Avatar /> My account
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => { navigate('/share') }}>
                        <ListItemIcon>
                            <AddCircleRoundedIcon fontSize="small" />
                        </ListItemIcon>
                        Add New Post
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/feedback') }}>
                        <ListItemIcon>
                            <FeedbackIcon fontSize="small" />
                        </ListItemIcon>
                        Feedback
                    </MenuItem>
                    <MenuItem onClick={()=>{setconformMessage("Do you want to logout");setOpen(true);setconformAction("forlogout");}}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                    </MenuItem>
                </Menu>
            </React.Fragment>
        </>
    );
}
